import api from './api';
import { TimesheetData } from '../types/django/timesheet';

export const timesheetService = {
  // Récupérer toutes les feuilles
  async getAll(): Promise<TimesheetData[]> {
    const response = await api.get('/timesheets/');
    return response.data?.results ?? response.data;
  },

async get(id: number): Promise<TimesheetData> { 
  const response = await api.get(`/timesheets/${id}/`);
  return response.data;
},

  // Récupérer le résumé de calcul dynamique de Django
  async getSummary(id: number): Promise<any> {
    const response = await api.get(`/timesheets/${id}/summary/`);
    return response.data;
  },

  // Soumettre une feuille
  async submit(id: number): Promise<any> {
    const response = await api.post(`/timesheets/${id}/submit/`);
    return response.data;
  },

  // Approuver une feuille de temps
  async approve(id: number): Promise<any> {
    const response = await api.post(`/timesheets/${id}/approve/`);
    return response.data;
  },

  // Refuser une feuille avec la raison obligatoire
  async reject(id: number, reason: string): Promise<any> {
    const response = await api.post(`/timesheets/${id}/reject/`, {
      rejection_reason: reason,
    });
    return response.data;
  },
// Exporter en Excel
  async exportExcel(id: number): Promise<void> {
    const response = await api.get(`/timesheets/${id}/export_excel/`, {
      responseType: 'blob',
    });

    let filename = `timesheet_${id}.xlsx`;
    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.includes('filename=')) {
      const matches = /filename="?([^"]+)"?/.exec(disposition);
      if (matches && matches[1]) {
        filename = matches[1];
      }
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Exporter en PDF
  async exportPdf(id: number): Promise<void> {
    const response = await api.get(`/timesheets/${id}/export_pdf/`, {
      responseType: 'blob',
    });

    let filename = `timesheet_${id}.pdf`;
    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.includes('filename=')) {
      const matches = /filename="?([^"]+)"?/.exec(disposition);
      if (matches && matches[1]) {
        filename = matches[1];
      }
    }

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
